<template>
	<div class="row">
		<div class="col-12 my-2" v-show="confInfo.confpayment">
			<h5>Payment Information</h5>
			<label class="text-muted">Cardholder's full name*</label><input type="text" class="form-control mb-3" v-model="cardholder.fullname" />
			<label class="text-muted">Cardholder's email address*</label><input type="text" class="form-control mb-3" v-model="cardholder.emailaddress" />
			<label class="text-muted">Cardholder's mobile number*</label><input type="text" class="form-control mb-3" v-model="cardholder.phone" />
			<input type="hidden" value="" name="stripeAmount" id="stripeAmount" v-model="stripeAmount">
			<fieldset>
				<div class="">  
					<label class="text-muted">Card number</label>
						<div class="small"><em>This charge will appear on your credit card statment as 'SOCAISLAND*{{descriptor.toUpperCase()}}'.</em></div>
					<div id="card-element" class="form-control my-2"></div>
				
					<!-- Used to display form errors. -->
					<div id="card-errors" class="my-2" role="alert" style="color:#ff0000;"> </div>
				</div>
			</fieldset> 
		</div>
		<div class="col-12 my-1 mb-5">
			<button class="btn btn-block btn-primary btn-lg" :disabled="!isFormValid||isBusy" @click="btnPayContinueClick" v-if="confInfo.confpayment">
				<span v-show="!isBusy">Pay and continue</span>
				<div class="spinner-border text-light" role="status" v-show="isBusy">
					<span class="sr-only">Loading...</span>
				</div>
			</button>
		</div>
	</div>
</template>
<script type="text/javascript" src="//js.stripe.com/v3/"></script>
<script>
import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);

const fb = require("../firebaseConfig")

export default {
	name: "PaymentForm",
	components: {
	},
	props:["orderData"],
    computed:{
		confId(){
            return this.$store.state.confId
        },
		confInfo(){
            return this.$store.state.confInfo
        },
        userProfile(){
            console.log(this.$store.state.userProfileDoc)
            return this.$store.state.userProfile
        },
		isFormValid(){
			const {
				fullname, emailaddress, phone
			} = this.cardholder
			if(!fullname || !emailaddress || !phone){
				return false;
			}
            return true
        }
    },
    data(){
        return{
			isBusy: false,
			register:{},
			cardholder:{},
			descriptor:"ROTARY7030",
            stripeAmount:0,
            fees:0,
            clientSecret:"",
		}
    },
    methods:{
		async btnPayContinueClick(){
			const {orderData} = this;
			this.isBusy = true
			const trxnId = orderData.id
            const tktPrice = Number(orderData.data.confticketprice)+0.50
            this.stripeAmount= Math.trunc((tktPrice/0.935)*100)

            if(this.clientSecret==""){
                if(this.stripeAmount <1) return false
                let striperesponse = await fetch(`${this.API_URL}/stripe/create/${trxnId}!${this.stripeAmount}!${encodeURI(this.cardholder.fullname)}!${encodeURI(this.confticket.name)}!${encodeURI(this.cardholder.emailaddress)}!USD!${encodeURI(this.confId)}!${this.descriptor}`).then((response)=> {
                    return response.json()
                })
                this.clientSecret = striperesponse.client_secret
                this.pytintent = striperesponse.payment_intent
            }
            console.log(this.clientSecret, this.pytintent)
            if(!this.clientSecret) {
                this.isBusy = false
                this.clientSecret = ""
                return false 
            }
            this.stripe.confirmCardPayment(this.clientSecret,
                {
                    payment_method: {
                    card: this.card,
                    billing_details: {
                        name: this.cardholder.fullname,
                        email: this.cardholder.emailaddress,
                        phone: this.cardholder.mobile,
                    },
                },
            }).then(async (result) =>{
                if (result.error) {
                    document.getElementById('card-errors').textContent = result.error.code + " - " + result.error.decline_code
                    this.isBusy = false
                    this.clientSecret = ""
                } else{
                    console.log('The payment has been processed!')
                    fb.ordersCollection.doc(String(trxnId)).update({status: "PAID"}).then(()=>{
						Vue.$toast.success("Payment successfully applied.", {position:"top"})
						this.isBusy = false;
					})
                    this.clientSecret = ""
                }
            })
		},	
    },
    mounted(){
		if(this.orderData) this.$store.dispatch("fetchConfProfile", this.orderData.data.confeventid);

		this.stripe = Stripe("pk_live_NO5i9A0rJetFGqZ99mLPeSpP") //pk_test_itCmziCcsavym8T71gROTOhj  pk_live_NO5i9A0rJetFGqZ99mLPeSpP
		var elements = this.stripe.elements()
		let style = {
			base: {
				color: '#32325d',
				fontFamily: 'Avenir, Helvetica, Arial, sans-serif',
				fontSmoothing: 'antialiased',
				fontSize: '1.15em',
				'::placeholder': {
						color: '#aab7c4'
				}
			},
			invalid: {
				color: '#fa755a',
				iconColor: '#fa755a'
			}
		}

		// Create an instance of the card Element.
		this.card = elements.create('card', {style: style})

		// Add an instance of the card Element into the `card-element` <div>.
		this.card.mount('#card-element');

		// Handle real-time validation errors from the card Element.
		let displayError = document.getElementById('card-errors')
		this.card.addEventListener('change', (event)=> {
			this.isBusy = false
			if (event.error) {
				displayError.textContent = event.error.message
			} else {
				displayError.textContent = ''
			}
		})
    }
}
</script>
